import { FC, HTMLAttributes } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {  useParams } from 'react-router-dom';

import { Button, Flex, Typography } from 'antd';
import cn from 'classnames';

import { OfferCard, OfferCompanyCard, OfferHeader } from 'entities/Offer';
import { CategoryEnum } from 'shared/api/client/codegen.api';
import { usePublicOffersRetrieveQuery } from 'shared/api/public/api';
import { STATUSES } from 'shared/consts';
import { EMainRoutes, EStatuses } from 'shared/typings';
import { OverlayLoader, Page, Text } from 'shared/ui';
import { OfferOverview } from 'widgets/Offer';

import '@mdxeditor/editor/style.css';

import styles from './Offer.module.scss';

interface IOfferProps extends HTMLAttributes<HTMLDivElement> {}

export const Offer: FC<IOfferProps> = ({ className, ...props }) => {
	const { slug } = useParams();
	const { t } = useTranslation();

	const { data, isFetching, isSuccess } = usePublicOffersRetrieveQuery(slug as string);
	const { description, category, name, deadline, price, attachments, type, created_at, id } = data || {};

	const handleProceed = async () => {
		location.href = `${window.location.origin}/${EMainRoutes.PUBLISHER}/${EMainRoutes.OFFER}/${id}/`;
	};
	return (
		<Page {...props} className={cn(className, styles.offer)}>
			{isSuccess && (
				<Flex vertical gap={24}>
					<Flex className={cn(styles.banner, styles.body)}>
						<Text className={styles.sidebar} fontSize={20}>
							<Trans i18nKey={'bannerText'}>Start earning <br/> right now!</Trans>
						</Text>
						<Flex gap={40} className={styles.main}>
							<Text type={"secondary"} fontSize={21}>{t('C&P is a platform for earning in the world of affiliate marketing through special placements.')}</Text>
							<Button type="primary" ghost>{t('About the platform')}</Button>
						</Flex>
					</Flex>
					<Flex gap={24} className={styles.body}>
						<Flex vertical gap={24} className={styles.sidebar}>
							<OfferCard
								deadline={deadline || undefined}
								price={price}
								publishedAt={created_at}
								id={id}
								primaryBtnText={t('Proceed the offer')}
								onPrimaryAction={() => handleProceed()}
							/>
							<OfferCompanyCard />
							<Button type="primary" ghost onClick={() => console.log('Other public offers')} block>
								{t('Other public offers')}
							</Button>
						</Flex>
						<Flex vertical gap={24} style={{ width: '100%' }} className={styles.main}>
							<OfferHeader
								name={name}
								category={category as CategoryEnum}
								type={type}
								status={STATUSES[EStatuses.DRAFT]}
							/>
							<OfferOverview description={description} attachments={attachments} />
							<Flex vertical gap={24} align="flex-start" style={{ padding: 24 }}>
								<Flex vertical gap={8} align="flex-start">
									<Typography.Title level={4} style={{ margin: 0 }}>{t('Discuss the details')}</Typography.Title>
									<Text color="tertiary">{t('Everything you write here will only be seen by the participants of the task.')}</Text>
								</Flex>
								<Button type="primary" onClick={() => console.log('Register and write')}>
									{t('Register and write')}
								</Button>
							</Flex>
						</Flex>
					</Flex>
				</Flex>
			)}
			{isFetching && <OverlayLoader />}
		</Page>
	);
};

export default Offer;
